var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayCricle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.07 19.82C18.88 19.82 18.69 19.7499 18.54 19.5999C18.25 19.3099 18.25 18.8299 18.54 18.5399C22.15 14.9299 22.15 9.05999 18.54 5.45999C18.25 5.16999 18.25 4.69 18.54 4.4C18.83 4.11 19.31 4.11 19.6 4.4C23.79 8.59 23.79 15.4099 19.6 19.5999C19.45 19.7499 19.26 19.82 19.07 19.82Z",
    fill: "#97A1C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.93001 19.82C4.74001 19.82 4.55001 19.7499 4.40001 19.5999C0.210007 15.4099 0.210007 8.59 4.40001 4.4C4.69001 4.11 5.17 4.11 5.46 4.4C5.75 4.69 5.75 5.16999 5.46 5.45999C1.85 9.06999 1.85 14.9399 5.46 18.5399C5.75 18.8299 5.75 19.3099 5.46 19.5999C5.31 19.7499 5.12001 19.82 4.93001 19.82Z",
    fill: "#97A1C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22.71C10.75 22.7 9.56002 22.4999 8.45002 22.1099C8.06002 21.9699 7.85 21.54 7.99 21.15C8.13 20.76 8.55002 20.55 8.95002 20.69C9.91002 21.02 10.93 21.2 12.01 21.2C13.08 21.2 14.11 21.02 15.06 20.69C15.45 20.56 15.88 20.76 16.02 21.15C16.16 21.54 15.95 21.9699 15.56 22.1099C14.44 22.4999 13.25 22.71 12 22.71Z",
    fill: "#97A1C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.3 3.34009C15.22 3.34009 15.13 3.33005 15.05 3.30005C14.09 2.97005 13.06 2.79004 11.99 2.79004C10.92 2.79004 9.90002 2.97005 8.94002 3.30005C8.55002 3.43005 8.12002 3.23009 7.98002 2.84009C7.84002 2.45009 8.05002 2.02007 8.44002 1.88007C9.55002 1.49007 10.75 1.29004 11.99 1.29004C13.23 1.29004 14.43 1.49007 15.54 1.88007C15.93 2.02007 16.14 2.45009 16 2.84009C15.9 3.15009 15.61 3.34009 15.3 3.34009Z",
    fill: "#97A1C2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73999 12V10.33C8.73999 8.25003 10.21 7.40002 12.01 8.44002L13.46 9.28005L14.91 10.12C16.71 11.16 16.71 12.86 14.91 13.9L13.46 14.74L12.01 15.58C10.21 16.62 8.73999 15.77 8.73999 13.69V12Z",
    fill: "#97A1C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCricle);
export default __webpack_public_path__ + "static/media/play-cricle.52250a79b0f807d2c93480aceb02db14.svg";
export { ForwardRef as ReactComponent };